import FormsActionTypes from 'redux/forms/types';

export const startFetchForms = (data) => ({
  type: FormsActionTypes.START_FETCH_FORMS,
  payload: data,
});

export const fetchFormsSuccess = (forms) => ({
  type: FormsActionTypes.FETCH_FORMS_SUCCESS,
  payload: forms,
});

export const fetchFormsFailure = (error) => ({
  type: FormsActionTypes.FETCH_FORMS_FAILURE,
  payload: error,
});

export const startFetchTiedApplications = () => ({
  type: FormsActionTypes.START_FETCH_APPLICATIONS_FORMS,
});

export const FetchTiedApplicationsSuccess = (data) => ({
  type: FormsActionTypes.FETCH_APPLICATIONS_FORMS_SUCCESS,
  payload: data,
});

export const FetchTiedApplicationsFailure = (error) => ({
  type: FormsActionTypes.FETCH_APPLICATIONS_FORMS_FAILURE,
  payload: error,
});

export const startCreateForms = (data, cb) => ({
  type: FormsActionTypes.START_CREATE_FORM,
  payload: { data, cb },
});

export const createFormsSuccess = (forms) => ({
  type: FormsActionTypes.CREATE_FORM_SUCCESS,
  payload: forms,
});

export const createFormsFailure = (error) => ({
  type: FormsActionTypes.CREATE_FORM_FAILURE,
  payload: error,
});

export const startDeleteForms = (id) => ({
  type: FormsActionTypes.START_DELETE_FORMS,
  id,
});

export const deleteFormsSuccess = (id) => ({
  type: FormsActionTypes.DELETE_FORMS_SUCCESS,
  payload: id,
});

export const deleteFormsFailure = (error) => ({
  type: FormsActionTypes.DELETE_FORMS_FAILURE,
  payload: error,
});

export const startDeactivateForms = (id, status) => ({
  type: FormsActionTypes.START_DEACTIVATE_FORM,
  id,
  status,
});

export const deactivateFormsSuccess = (data) => ({
  type: FormsActionTypes.DEACTIVATE_FORM_SUCCESS,
  payload: data,
});

export const deactivateFormsFailure = (error) => ({
  type: FormsActionTypes.DEACTIVATE_FORM_FAILURE,
  payload: error,
});

export const searchForms = (searchPattern, pageSize) => ({
  type: FormsActionTypes.SEARCH_FORMS,
  data: { searchPattern, pageSize },
});

export const searchFormsByStatus = (data) => ({
  type: FormsActionTypes.SEARCH_FORMS_BY_STATUS,
  payload: data,
});

export const searchFormsResult = (payload) => ({
  type: FormsActionTypes.SEARCH_FORMS_RESULTS,
  payload,
});

export const fetchSingleForm = (id) => ({
  type: FormsActionTypes.FETCH_SINGLE_FORM,
  id,
});

export const fetchSingleFormSuccess = (data) => ({
  type: FormsActionTypes.FETCH_SINGLE_FORM_SUCCESS,
  payload: data,
});

export const fetchSingleFormFailure = (error) => ({
  type: FormsActionTypes.FETCH_SINGLE_FORM_FAILURE,
  payload: error,
});
